import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../others/LoadingComponent";

function CardBookingForm({ setShowCardForm, setCartList, clearCart }) {
  const link = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;
  const pageFullUrl = window.location.href;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClearCart = () => {
    dispatch(clearCart());
  };

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const cart = useSelector((state) => state.cart.services);

  console.log("cart is  33:", cart);

  const totalPrice = cart.reduce(
    (sum, e) => sum + e.discountedPrice * e.quantity,
    0,
  );

  const totalQuantity = cart.reduce((sum, item) => sum + item.quantity, 0);

  console.log(totalQuantity);

  // const totalQuantityByType = cart.reduce((acc, { AC_Type, quantity }) => {
  //   acc[AC_Type] = (acc[AC_Type] || 0) + quantity;
  //   return acc;

  // }, {});

  const getServiceSummary = (cart) => {
    return cart.reduce(
      (acc, { AC_Type, quantity }) => {
        if (!AC_Type || quantity == null) return acc;

        acc.grouped[AC_Type] = (acc.grouped[AC_Type] || 0) + quantity;
        acc.total += quantity;
        return acc;
      },
      { grouped: {}, total: 0 },
    );
  };

  const totalQuantityWithType = getServiceSummary(cart);

  // console.log("ac with type",totalQuantityByType);
  // Example output: { Split: 3, Window: 1 }

  //  Clalulation alueof add to card  ::::::::::::::::::::::::::::::::::::::::::::::::

  function groupServicesDetailed(cart) {
    const grouped = {};

    cart.forEach(({ AC_Type, heading }) => {
      if (!grouped[AC_Type]) {
        grouped[AC_Type] = { AC_Type, numberOfServices: 0, headings: [] };
      }
      grouped[AC_Type].numberOfServices++;
      grouped[AC_Type].headings.push(heading);
    });

    return Object.values(grouped);
  }

  const detailedGrouped = groupServicesDetailed(cart);

  console.log(detailedGrouped);

  // Calculation of service dratils with Ac Type and  number f Ac

  const getFormattedServiceSummary = (cart) => {
    const serviceMap = {};

    cart.forEach(({ AC_Type, heading, quantity }) => {
      if (!AC_Type || !heading || !quantity) return;

      const key = `${AC_Type.trim()} - ${heading.trim()}`;
      serviceMap[key] = (serviceMap[key] || 0) + quantity;
    });

    const summaryText = Object.entries(serviceMap)
      .map(([key, count]) => `${key} (${count})`)
      .join(", ");

    return [{ serviceSummary: `Services: ${summaryText}` }];
  };

  const serviceSummaryDetails = getFormattedServiceSummary(cart);
  console.log(serviceSummaryDetails);

  // end::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [data, setdata] = useState({
    pageUrl: pageFullUrl,
    cardData: cart,
    serviceName: serviceSummaryDetails,
    sericesQuantity: totalQuantityWithType.total,
    Actype: totalQuantityWithType.grouped,
    totalPrice: totalPrice,
    name: "",
    phone: "",
    serviceDate: "",
    serviceTime: "",
    city: "",
    brand: "",
    paymentMethod: "",
    // completeAddress:""
  });

  const today = new Date().toISOString().split("T")[0];

  const timeSlots = [
    { value: "8:00am-10:00am", hour: 8 },
    { value: "10:00am-12:00pm", hour: 10 },
    { value: "12:00pm-2:00pm", hour: 12 },
    { value: "2:00pm-4:00pm", hour: 14 },
    { value: "4:00pm-6:00pm", hour: 16 },
    { value: "6:00pm-8:00pm", hour: 18 },
  ];

  const getFilteredTimeSlots = () => {
    if (data.serviceDate !== today) return timeSlots;
    const currentHour = new Date().getHours();
    return timeSlots.filter((slot) => slot.hour > currentHour);
  };

  const handleChange = (e) => {
    const value = e.target.value;

    setdata({
      ...data,
      [e.target.name]: value,
    });
  };

  const handleNumber = (e) => {
    const value = e.target.value;

    setError(null);
    if (value.length <= 10) {
      setdata({
        ...data,
        phone: value,
      });
    }
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setdata({
      ...data,
      serviceDate: value,
      serviceTime: "",
    });
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // IPadress get functionality ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [userAgent, setUserAgent] = useState("");
  const [ipAddress, setIpAddress] = useState(null);

  const getIp = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");

      if (response.ok) {
        const res = await response.json();
        setIpAddress(res.ip);
      } else {
        console.log(false);
      }
    } catch (error) {
      console.log("error in getting few details");
    }
  };

  useEffect(() => {
    getIp();
    setUserAgent(navigator.userAgent);
  }, []);

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const updatedData = {
    remoteIP: ipAddress,
    userAgent: userAgent,
    formUrl: pageFullUrl,
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };




  // Add Logic to pay:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

   const loadRazorpayScript = () => {
  return new Promise((resolve) => {

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";

    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.body.appendChild(script);

  });
};





const handlePrepaidPayment = async () => {

  const res = await loadRazorpayScript();

  if (!res) {
    setError("Razorpay SDK failed to load");
    return;
  }

  try {

    const orderRes = await fetch(`${link}/ac-booking-create-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        totalAmount: totalPrice
      })
    });

    const order = await orderRes.json();

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: order.amount,
      currency: "INR",
      order_id: order.orderId,
      name: "AC Service Booking",

      handler: async function (response) {

        const verifyRes = await fetch(`${link}/ac-booking-verify-payment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: apiKey
          },
          body: JSON.stringify({
            ...response,
            bookingData: { ...data, ...updatedData }
          })
        });

        if (verifyRes.ok) {

          handleClearCart();
          setCartList(false);
          setShowCardForm(false);

          navigate("/thank-you");

        } else {

          setError("Payment verification failed");

        }
      }
    };

    const paymentObject = new window.Razorpay(options);

    paymentObject.open();

  } catch (error) {

    setError("Payment error");
    console.log(error);

  }

};
















const handleSubmitForm = async (e) => {

  e.preventDefault();

  if (data.phone.length !== 10) {
    setError("Enter valid phone number");
    return;
  }

  // PREPAID
  if (data.paymentMethod === "prepaid") {
    handlePrepaidPayment();
    return;
  }

  // POSTPAID
  if (data.paymentMethod === "postpaid") {

    setLoading(true);

    try {

      const response = await fetch(`${link}/booking-form/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apiKey
        },
        body: JSON.stringify({ ...data, ...updatedData })
      });

      if (response.ok) {

        handleClearCart();

        setCartList(false);
        setShowCardForm(false);

        navigate("/thank-you");

      } else {

        const res_data = await response.json();
        setError(res_data.message);

      }

    } catch (error) {

      setError("Server Error");

    }

    setLoading(false);

  }

};










// is old one 

  // const handleSubmitForm = async (e) => {
  //   e.preventDefault();

  //   setLoading(true);

  //   if (data.phone.length === 10) {
  //     const filledDate = localStorage.getItem("formFilledDate");
  //     const today = getTodayDate();
  //     if (filledDate === today) {
  //       // alert("You've already filled out the form. Please try calling us now.");
  //       setError(
  //         "You've already filled out the form. Please try calling us now.",
  //       );
  //     } else {
  //       console.log("final object data", data);

  //       try {
  //         const response = await fetch(`${link}/booking-form/`, {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: apiKey,
  //           },
  //           body: JSON.stringify({ ...data, ...updatedData }),
  //         });

  //         console.log("form data", data);

  //         if (response.ok) {
  //           localStorage.setItem("formFilledDate", today);

  //           handleClearCart();

  //           setCartList(false);
  //           setShowCardForm(false);

  //           navigate("/thank-you");
  //         } else {
  //           const res_data = await response.json();

  //           setError(res_data.message);
  //         }
  //       } catch (error) {
  //         setError("Server Error");
  //       }
  //     }

  //     setLoading(false);
  //   } else {
  //     setError("enter the valid number");
  //   }
  // };




















  return (
    <div className="card-booking-form-bg">
      {loading ? <LoadingComponent /> : ""}

      <div className="card-booking-form">
        <div className="confirm-booking">
          <div>
            <div className="confirm-booking-close-btn">
              <i
                className="fa-solid fa-circle-xmark"
                onClick={(e) => setShowCardForm(false)}
              ></i>
            </div>
            <div className="confirm-booking-heading">Confirm Booking</div>

            <div className="confirm-booking-form">
              <form onSubmit={handleSubmitForm}>
                <div className="confirm-booking-form-row">
                  <div>
                    <label>Name*</label>
                    <input
                      required
                      type="text"
                      placeholder="Enter Your Name"
                      name="name"
                      value={data.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div>
                    <label>Number*</label>
                    <input
                      required
                      type="number"
                      placeholder="Enter Your Number"
                      name="phone"
                      value={data.phone}
                      onChange={handleNumber}
                    />
                  </div>
                </div>

                <div className="confirm-booking-form-r">
                  <div>
                    <label>Brand/Brands*</label>

                    <input
                      required
                      type="text"
                      placeholder="Enter Brand Name"
                      name="brand"
                      value={data.brand}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div>
                  <label>Complete address*</label>
                  <input
                    required
                    type="text"
                    placeholder="Enter Complete address"
                    name="city"
                    value={data.city}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label>Select payment method</label>

                  <select
                    name="paymentMethod"
                    value={data.paymentMethod || ""}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="prepaid">Prepaid</option>
                    <option value="postpaid">Postpaid</option>
                  </select>
                </div> 

              

                {error ? (
                  <div className="confirm-booking-form-error">{error}</div>
                ) : (
                  ""
                )}

                <button>Book Now</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardBookingForm;
